import { EwaThunk, FlowioThunkCreator } from "../types";
import {
  setIsLoading,
  setStateChangedInfo,
  setStateChangedSettings,
  setUserInfo,
  setUserSettings,
} from "./actionCreators";
import {
  fetchUserSettings,
  postUserAcceptGuide,
  postUserSettings,
} from "../../requests/user/requestCreators";
import { getUserSlice } from "./selectors";
import { getUserId } from "../login/selectors";
import { getLocaleString } from "../localization/selectors";
import {
  requestGetUser,
  updateSettingsUserData,
} from "../../requests/users/requestCreators";
import { SuccessChangeLanguage } from "../localization/actions";
import { changeLanguage } from "../../requests/localization/requestCreators";
import flowioast from "../../utils/flowioast";

export const fetchUserDataThunk = (): EwaThunk => (dispatch, getState) => {
  const state = getState();
  const userId = getUserId(state);
  const localization = getLocaleString(state);

  dispatch(setIsLoading({ isLoading: true }));

  // TODO: paralelně
  fetchUserSettings()
    .then(({ data: userSettings }) => {
      if (userId) {
        requestGetUser(userId)
          .then(({ data: user }) => {
            const { userName, email, showedGuide } = user;
            const userInfo = {
              userName,
              email,
              showedGuide,
              stateChanged: false,
            };
            dispatch(setUserInfo({ userInfo }));
          })
          .catch((e) => {
            flowioast.error.fromIntlBase("user_settings.fetch.singular", e);
          });
      }
      dispatch(
        setUserSettings({
          userSettings: {
            ...userSettings,
            language: localization,
            stateChanged: false,
          },
        })
      );
    })
    .catch((e) => {
      flowioast.error.fromIntlBase("user_settings.fetch.singular", e);
    })
    .finally(() => dispatch(setIsLoading({ isLoading: false })));
};

type PostUserInformation = FlowioThunkCreator<Record<string, unknown>>;
export const postUserInformationThunk: PostUserInformation =
  () => (dispatch, getState) =>
    Promise.resolve().then(() => {
      const state = getState();
      const userSlice = getUserSlice(state);
      const userId = getUserId(state);

      if (!userId) return;

      dispatch(setIsLoading({ isLoading: true }));

      const { userName, email } = userSlice.information;

      updateSettingsUserData({ userName, email }, userId)
        .then(() => dispatch(setStateChangedInfo({ newState: false })))
        .catch((e) => {
          flowioast.error.fromIntlBase("user_settings.update.singular", e);
        })
        .finally(() => dispatch(setIsLoading({ isLoading: false })));
    });

type PostUserSettings = FlowioThunkCreator<Record<string, unknown>>;
export const postUserSettingsThunk: PostUserSettings =
  () => (dispatch, getState) =>
    Promise.resolve().then(() => {
      const state = getState();
      const userSlice = getUserSlice(state);
      const localization = getLocaleString(state);

      const { stateChanged, language, ...userSettings } = userSlice.settings;

      dispatch(setIsLoading({ isLoading: true }));

      postUserSettings(userSettings)
        .then(async () => {
          dispatch(setStateChangedSettings({ newState: false }));

          if (localization === language) return;

          await changeLanguage(language);
          dispatch(SuccessChangeLanguage(language));
        })
        .catch((e) => {
          flowioast.error.fromIntlBase("user_settings.update.singular", e);
        })
        .finally(() => dispatch(setIsLoading({ isLoading: false })));
    });

export const postUserAcceptGuideThunk = (): EwaThunk => (dispatch) =>
  Promise.resolve().then(() => {
    dispatch(setIsLoading({ isLoading: true }));

    postUserAcceptGuide()
      .then(() => dispatch(setStateChangedInfo({ newState: false })))
      .catch((e) => {
        flowioast.error.fromIntlBase("user_settings.update.singular", e);
      })
      .finally(() => {
        dispatch(setIsLoading({ isLoading: false }));
        dispatch(fetchUserDataThunk());
      });
  });
